<template>
    <b-row>
       <b-col md="12" class="mt-3">
           <b-card>
               <div slot="header">
           <b-row>
               <b-col>
                   <strong> Hub Configuration Details</strong> 
               </b-col>
               
           </b-row>
           

       </div>
           <div>
               <b-row>
         
                   <b-col sm="12" class="text-right  " >
               <a :href="loadurl" target="_blank" class="ml-3">
                   <b-button variant="primary"  size="md" @click="downlaodloadurl">Download</b-button>
               </a>
           </b-col>
              
               </b-row> 
           </div>

          

           <div class="text-right">
               <b>Total Records : <strong style="color: red;">{{totalRows}}</strong></b>
           </div>
           
          
           <b-table show-empty responsive :busy="isBusy" :items="attendancedatarows" :fields="fields"  :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"  @filtered="onFiltered" style="overflow-x: auto !important;"> 

               <div slot="table-busy" class="text-center text-danger my-2">
                 <b-spinner class="align-middle">
                 </b-spinner>
                 <strong>Loading...</strong>
               </div> 
             
           
           </b-table>
           
           <paginate class="pt-2"
  
               :page-count="noofpages"
               :page-range="10"
               :margin-pages="2"
               :click-handler="clickCallback"
               :prev-text="'Prev'"
               :next-text="'Next'"
               :container-class="'pagination'"
               :page-class="'page-item'">
           </paginate>

           </b-card>

         
       </b-col>

   </b-row>

    
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
data() {
   return {
       isBusy: false, 
       
       fields :[],
       EBN_expriryCount :[],
       attendancedatarows:[],
       isBusy : false,
       noofpages:'',
       pageNum:1,
       searching :[],
       searchvaluesarr:[],
       totalRows :0,
       CheckLoadID :[],
       SelectLoadID :[],
       selectDateFrom: '',
       route_id : null,
       isCheckAll: false,
       documenttype:'',
       hubname:'',
       shift:'',
       shiftstart:'',
       shiftend:'',
       loadurl :'',
       hubid:''
   }
},

created() {
   var userdata = localStorage.getItem("userData");
   var userInfo = JSON.parse(userdata);
   this.User_type = userInfo.user_type;
   console.log("userInfo", userInfo);
   this.hubid = userInfo.hub_id
//    this.route_id = this.$route.params.id;
    
   //console.log("this.route_id",this.route_id)
   this.hubconfigurationlist(this.pageNum);
   // this.manuallyUpdateRecord();
 
},
mounted(){
  // this.hubconfigurationlist()
},
methods: {
   checklenght(value){
       console.log("value",value)
       if (value.length==0) {
       this.searching=[]
       this.totalRows=0
       this.searchvaluesarr=[]
       this.hubconfigurationlist(this.pageNum)
       }
   },

   clickCallback(pageNum){

       this.hubconfigurationlist(pageNum);
   },
   hubconfigurationlist : function(pageNo){     
       
      this.isBusy=true;

    //   if(this.typelist.includes(this.documenttype)){

 
       this.fields=[
            
               { key: 'hubname', label : 'Hub Name', sortable: true},
               { key: 'shiftname', label : 'Shift', sortable: true},
               { key: 'shiftstart', label : 'Shift Start', sortable: true},
               { key: 'shiftend', label : 'Shift End', sortable: true},
               { key: 'totalshifthours', label : 'Total_Shift_Hours', sortable: true},
               { key: 'workinghours', label : 'Working_Hours', sortable: true},
               { key: 'teabreakstart', label : 'Tea Break Start', sortable: true},
               { key: 'teabreakend', label : 'Tea Break End', sortable: true},
               { key: 'lunchbreakstart', label : 'Lunch Break Start', sortable: true},
               { key: 'lunchbreakend', label : 'Lunch Break End', sortable: true},
               { key: 'totalbreak', label : 'Total Break', sortable: true},
           ]
       
       var Obj = {       
           page_no:`${pageNo}`,
           hubid:this.hubid ? this.hubid : null,
           usertype:this.User_type
       };
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getHubConfigurationDetails`,Obj)
       .then(result => {
           console.log("result",result)
           this.isBusy=false;
           if (result.body.returnmsg === "successful") {
               let v = result.body.returnvalue
                   this.attendancedatarows = v
                   this.totalRows = result.body.rowcount
                   this.noofpages=parseInt(this.totalRows)/20;
                   this.noofpages=Math.ceil(this.noofpages);

           }else{
               this.attendancedatarows = []
               this.totalRows = 0
            //   this.EBN_expriryCount=[];
           }
       }).catch(ex => {
           console.log("error", ex);
       });
   //}
   },
   downlaodloadurl(){
 //  var userdata = localStorage.getItem("userData");
   //var userInfo = JSON.parse(userdata);
   this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/getCSVhubconfigurationdata?hubid=${this.hubid}&usertype=${this.User_type}`
   console.log("this.loadurl",this.loadurl)
 },
 formatTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

   const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
},
subtracttwodates(date1,date2,oseconds){
    const timestamp1 = new Date(date1);
const timestamp2 = new Date(date2);
 const differenceInMilliseconds = timestamp2 - timestamp1;

 const millisecondsToSubtract = oseconds * 1000;

 const newDifferenceInMilliseconds = differenceInMilliseconds - millisecondsToSubtract;

 const newTotalSeconds = Math.floor(newDifferenceInMilliseconds / 1000);

 const newHours = Math.floor(newTotalSeconds / 3600);
const newMinutes = Math.floor((newTotalSeconds % 3600) / 60);
const newSeconds = newTotalSeconds % 60;

 const pad = num => String(num).padStart(2, '0');

 const newFormattedTimeDifference = `${pad(newHours)}:${pad(newMinutes)}:${pad(newSeconds)}`;

    return newFormattedTimeDifference

},
calculateTimeDifference(time1, time2) {
     const [h1, m1, s1] = time1.split(':').map(Number);
    const [h2, m2, s2] = time2.split(':').map(Number);

     const date1 = new Date(2024, 0, 1, h1, m1, s1);
    const date2 = new Date(2024, 0, 1, h2, m2, s2);

     const difference = date1 - date2;
  
    const absDifference = Math.abs(difference);
    const diffDate = new Date(absDifference);

    const hours = diffDate.getUTCHours().toString().padStart(2, '0');
    const minutes = diffDate.getUTCMinutes().toString().padStart(2, '0');
    const seconds = diffDate.getUTCSeconds().toString().padStart(2, '0');
  
  const isPositive = difference >= 0;
    const formattedTime = `${hours}:${minutes}:${seconds}`;
    
    return {
        timeFormat: formattedTime,
        sign: isPositive ? 'positive' : 'negative'
    };
 
},
formatDateComponent(value) {
    return value < 10 ? `0${value}` : value;
},
getCurrentTimestamp(odate) {
    const now = new Date(odate);
    
    const year = now.getFullYear();
    const month = this.formatDateComponent(now.getMonth() + 1); // Months are 0-based
    const day = this.formatDateComponent(now.getDate());
    const hours = this.formatDateComponent(now.getHours());
    const minutes = this.formatDateComponent(now.getMinutes());
    const seconds = this.formatDateComponent(now.getSeconds());
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
getsumtwodates(date1,date2){
    const timestamp1 = new Date(date1);
const timestamp2 = new Date(date2);
 const differenceInMilliseconds = timestamp2 - timestamp1;

 
 const newDifferenceInMilliseconds = differenceInMilliseconds  

 const newTotalSeconds = Math.floor(newDifferenceInMilliseconds / 1000);

 const newHours = Math.floor(newTotalSeconds / 3600);
const newMinutes = Math.floor((newTotalSeconds % 3600) / 60);
const newSeconds = newTotalSeconds % 60;

 const pad = num => String(num).padStart(2, '0');

 const newFormattedTimeDifference = `${pad(newHours)}:${pad(newMinutes)}:${pad(newSeconds)}`;

    return newFormattedTimeDifference
}


},
computed: {
//   rows() {
//     return this.EBN_expriryCount.length
//   }
},
}
</script>